import Axios from "axios";

export const SelectVendeur = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/NOME?cat=VD&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({
        type: "VD_SELECT",
        payload: response.data,
      });
    });
  };
};
